/* eslint-disable react/jsx-no-target-blank */
import { useIntl } from 'react-intl'
import { SidebarMenuItem } from './SidebarMenuItem'
import { useDataLayerValue } from '../../../../../DataLayer'

const SidebarMenuMain = () => {
  const intl = useIntl()
  const [{ policies }] = useDataLayerValue()

  return (
    <>
      {[22.2].some((number) => policies?.includes(number)) && (
        <SidebarMenuItem
          to='/vehicle-monitoring'
          icon='/media/icons/duotune/maps/map002.svg'
          title='Monitoring MAP'
          fontIcon='bi-layers'
        />
      )}
      {[22.1].some((number) => policies?.includes(number)) && (
        <SidebarMenuItem
          to='/assign-vehicle-view'
          icon='/media/icons/duotune/maps/map003.svg'
          title='Available Vehicles'
          fontIcon='bi-layers'
        />
      )}
    </>
  )
}

export { SidebarMenuMain }
